import CardBoxLayout from "../../layout/cardBoxLayout";
import AccordionCommon from "@/shared/components/common/accordion";
import { dataAccordion } from "./dataAccordion";
import CustomButton from "@/shared/components/kit/button";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import StackKit from "@/shared/components/kit/stack";
import { useNavigate } from "react-router";
import { toPersianNumber } from "@/hooks/useThousandsSeparator";
/**
 * Content
 *
 * نمایش محتوای پرسش‌های متداول و امکان ارسال پیام به ادمین.
 *
 * ویژگی‌ها:
 * - استفاده از CardBoxLayout برای قاب‌بندی
 * - نمایش لیست آکاردئون با داده‌های dataAccordion
 * - امکان ناوبری به صفحه پیام‌رسانی به ادمین با استفاده از react-router
 * - نمایش هزینه ارسال پیام به ادمین به صورت عدد فارسی
 *
 * استفاده:
 * @returns JSX.Element
 */
// Task Response: کد درست و بهینه است، فقط نکته کوچک:
// 1. map روی dataAccordion بدون بررسی null/undefined استفاده شده است. بهتر است مطمئن شوید که dataAccordion همیشه آرایه است.
// 2. کامپوننت AccordionCommon به درستی key دریافت کرده و از useFadeTransition برای انیمیشن استفاده شده است.
// 3. استفاده از toPersianNumber برای نمایش عدد 20 کاملاً صحیح است.

const Content = () => {
  const navigate = useNavigate();
  return (
    <CardBoxLayout className="flex flex-col gap-4">
      {dataAccordion?.map((item) => (
        <AccordionCommon key={item.id} title={item.title} useFadeTransition>
          {item.description}
        </AccordionCommon>
      ))}
      <StackKit direction={'row'} justifyContent={'space-between'} alignItems={"center"} width={'100%'}>
        <CustomButton onClick={() => {navigate("/support/message");}}>
          <TypoGraphyKit variant="body1">
            ارسال پیام به ادمین {toPersianNumber(20)} کارت
          </TypoGraphyKit>
        </CustomButton>
      </StackKit>
    </CardBoxLayout>
  );
};

export default Content;
